import { Outlet, Navigate } from 'react-router-dom';
import { brand } from '@frontdesk/config';
import { useAuth } from '../lib/auth';

export function AuthLayout() {
  const user = useAuth((s) => s.user);
  const tenantId = useAuth((s) => s.tenantId);

  if (tenantId && user) {
    return <Navigate to="/app" replace />;
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--color-surface-secondary)',
        padding: 'var(--space-4)',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '420px',
          padding: 'var(--space-8)',
          background: 'var(--color-surface-primary)',
          borderRadius: 'var(--radius-xl)',
          boxShadow: 'var(--shadow-lg)',
        }}
      >
        <div
          style={{
            textAlign: 'center',
            marginBottom: 'var(--space-6)',
            fontSize: 'var(--text-2xl)',
            fontWeight: 700,
            color: 'var(--color-brand-primary)',
          }}
        >
          {brand.appName}
        </div>
        <Outlet />
      </div>
    </div>
  );
}
